<!--
================================================
Composant gérant le formulaire d'inscription
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="SignupComp">
        <modal-terms-comp></modal-terms-comp>
        <div class="columns mainContainer">

            <div class="column is-three-fifths formColumn">

                <div class="columns">
                    <div class="column"></div>

                    <div class="column is-9 columnContForm">
                        <form action="" v-on:keyup.enter="validateBeforeSubmit">


                            <h1 class="is-size-4">{{ $t("inscription") }}</h1>

                          <!-- INVIATION CODE DÉSACTIVÉ  @since 0.22.0

                          POUR RÉACTIVER IL SUFFIT :
                           * DE DÉCOMMENTER CE CHAMPS +  LES TESTS CYPRESS (CHERCHER "@since 0.22.0 )
                           * DE RÉACTIVER invitationCodeEnabled" DANS LE BACKEND

                            <div class="field">
                                <div class="control">
                                    <input class="input" v-model="invitationCode" v-validate="'required|invitationCodeCheck'"
                                           data-vv-validate-on="change" id="signup_invitation_code"
                                           data-vv-delay="700"
                                           name="signup_invitation_code" type="text"
                                           v-bind:placeholder="$t('cléDInvitation')">
                                </div>

                                <p class="help is-info has-text-left">{{$t('cléDInvitation')}}
                                    ({{$t("cronocloudEstActuellementEnBetaPrive")}})
                                </p>

                                <p class="help is-warning has-text-left" id="error_signup_invitation_code">{{
                                    errors.first('signup_invitation_code')
                                    }}</p>


                            </div>
                            -->

                            <div class="field">
                                <div class="control">
                                    <input class="input" v-model="organization" v-validate="'min:2|max:50'" id="signup_organization"   data-vv-delay="700"
                                           name="signup_organization" type="text"
                                           v-bind:placeholder="$t('organisation(optionnel)')">
                                </div>
                                <p class="help is-danger has-text-left" id="error_signup_organization">{{
                                    errors.first('signup_organization') }}</p>
                            </div>

                            <div class="field">
                                <div class="control">
                                    <!--<label class="label">{{$t('email')}}</label>-->
                                    <input id="username4Manager" type="text" style="display:none" autocomplete="username" v-bind:value="email">
                                    <input class="input" v-model="email"
                                           autocomplete="email"
                                           v-validate="'required|email|emailAvailabilityCheck'"
                                           data-vv-validate-on="change" id="signup_email"
                                           name="signup_email" type="email" v-bind:placeholder="$t('email')">
                                </div>
                                <p class="help is-danger has-text-left" id="error_signup_email">{{
                                    errors.first('signup_email') }}</p>

                              <p class="help is-danger has-text-left"  v-show="disposableEmail" id="error_signup_email_disposable">{{
                                  $t('VousNePouvezPasVousInscrireAvecCetteAdresse') }}</p>
                            </div>


                            <div class="field is-horizontal">

                                <div class="field-body">
                                    <div class="field">
                                        <div class="control">
                                            <input class="input" v-model="firstname" v-validate="'required|min:2|max:80'"
                                                   id="signup_firstname" name="signup_firstname" type="text"
                                                   autocomplete="given-name"
                                                   data-vv-delay="700"
                                                   v-bind:placeholder="$t('prénom')">
                                        </div>
                                        <p class="help is-danger has-text-left" id="error_signup_firstname">{{
                                            errors.first('signup_firstname') }}</p>
                                    </div>


                                    <div class="field">
                                        <div class="control">
                                            <input class="input" v-model="name" v-validate="'required|min:2|max:255'"
                                                   id="signup_name" name="signup_name" type="text"
                                                   data-vv-delay="700"
                                                   v-bind:placeholder="$t('nom')" autocomplete="family-name"
                                            >
                                        </div>
                                        <p class="help is-danger has-text-left" id="error_signup_name">{{
                                            errors.first('signup_name') }}</p>
                                    </div>

                                </div>

                            </div>


                          <div class="field has-addons">
                            <div class="control is-expanded">
                              <input class="input"
                                     v-model="password" v-validate="'required|min:6|max:20'" id="signup_password"
                                     name="signup_password" v-bind:type="passwordFieldType"
                                     v-bind:placeholder="$t('motDePasse')"
                                     autocomplete="new-password"
                                     data-vv-delay="700"
                              >
                            </div>

                              <div class="control" >
                                <a id="switchPasswordReveal" class="button is-small is-right passwordReveal" v-on:click="toggleRevealPwd()" :title="passwordFieldType=='text' ? $t('masquerLeMotDePasse') : $t('afficherLeMotDePasse') ">
                                  <font-awesome-icon class="icon" v-if="passwordFieldType=='text'" :icon="['fas', 'eye-slash']" />
                                  <font-awesome-icon class="icon" v-else :icon="['fas', 'eye']" />
                                </a>
                              </div>

                            </div>

                          <p class="help is-danger has-text-left" id="error_signup_password">{{
                              errors.first('signup_password')
                            }}</p>


                          <div class="cgvLink">

                                <input type="checkbox" v-model="termsAccepted" v-validate="'required'" id="signup_cgv" name="signup_cgv">
                                <i18n path="jAccepteLes" tag="label" for="signup_cgv" class="checkbox">
                                    <a id="termsLink" v-on:click="openModalTerms()">{{ $t('conditionsDUtilisation') }}</a>
                                </i18n>
                                <p class="help is-danger has-text-centered" id="error_signup_cgv">{{errors.first('signup_cgv') }}</p>

                            </div>

                            <input type="hidden" name="locale" v-bind:value="locale">
                            <input type="hidden" name="timezone" v-bind:value="detectedTimezone">


                            <div class="field">
                                <a v-on:click="validateBeforeSubmit" id="formSubmitBtn" v-bind:class="{'is-loading':isSubmiting}" class="button  is-fullwidth signupBtn">{{$t("creerMonCompte")}}</a>
                            </div>


                            <div class="alreadySigned">
                                <span class="has-text-info">{{$t("dejaInscrits")}} </span>
                                <span class="has-text-link">
                                    <router-link id="loginLink" v-bind:to="{ name: 'login'}"> {{$t("connectez-vous")}} </router-link>
                                </span>

                            </div>


                        </form>
                    </div>
                    <div class="column"></div>

                </div>


            </div>

            <div class="column is-two-fifths is-hidden-mobile infoColumn" id="infoColumn">

              <div class="logo">
                <router-link v-bind:to="{ name: 'home', params: {locale: $route.params.locale}}">
                    <img src="../assets/img/AppLogo.png" alt="Cronocloud App" width="164" height="29" class="logoImg">
                </router-link>
              </div>

                <div class="columns">
                    <div class="column"></div>
                    <div class="column is-11">

<!--                        <div class="featList">-->

<!--                            <h4>{{$t("pourquoiVousInscrire")}}</h4>-->
<!--                            <ul class="">-->
<!--&lt;!&ndash;                                <li> {{$t("votrePointeusePreteEn5min")}}</li>&ndash;&gt;-->
<!--                                <li> {{$t("simpleAUtiliser")}}</li>-->
<!--                                <li> {{$t("fonctionneSurSmartphoneEtOrdinateurs")}}</li>-->
<!--                                <li> {{$t("pasDInstallation")}}</li>-->
<!--                                <li> {{$t("100%Gratuit")}}</li>-->
<!--                            </ul>-->

<!--                        </div>-->

<!--                      <img src="../assets/img/welcomeIllustration.png" alt="Cronocloud App" width="300" class="illustration">-->

                      <div class="reviewCont">
                        <review-comp v-bind:review="reviews[randomReview]"></review-comp>
                      </div>

                    </div>


                    <div class="column"></div>
                </div>


            </div>

        </div>

    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import ModalTermsComp from "./ModalTermsComp";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import SentryMixin from "../mixins/SentryMixin.js";
    import InitialHydrationMixin from "../mixins/InitialHydrationMixin.js";
    import TimezoneMixin from "../mixins/TimezoneMixin.js";
    import TrackingMixin from "../mixins/TrackingMixin.js";
    import MarketingAutomationMixin from "../mixins/MarketingAutomationMixin.js";
    import ReviewComp from "@/components/ReviewComp";
    import _ from 'lodash'

    export default {
        name: 'SignupComp',
        components: {
          ReviewComp,
            ModalTermsComp,

        },
      mixins: [GlobalErrorNotification, SentryMixin, InitialHydrationMixin, TimezoneMixin, TrackingMixin, MarketingAutomationMixin],
      data: function () {
        return {

          // champs du formulaire
          invitationCode: '', // 'Startway-2019-alpha-001',
          email: '',
          organization: '',
          name: '',
          firstname: '',
          password: '',
          termsAccepted: '',
          locale: this.$route.params.locale,      // {string} la locale récup. dans l'url
          isSubmiting: false,     // indique si le formulaire est en cours de soumission
          detectedTimezone: null, // le timezone detecté
          loginFrom: '', // String (browser/pwa)
          passwordFieldType: 'password',// String | le type du champs passwork (password/text)
          disposableEmail: false, // Bool | true si l'email saisi est une adresse jetable

          randomReview : _.random(0,4),
          reviews: [
            {
              author: "Boulenouar Khelifa",
              pic: 'reviewBoulPic.jpeg',
              stars:5,
              position: this.$t('reviewBoulenouarPosition'),
              company: "fastnfluid",
              text: this.$t("reviewBoulenouar")
            },
            {
              author: "Julien Schermann",
              pic: 'reviewJulPic.png',
              stars:5,
              position: this.$t('reviewJulienPosition'),
              company: "Proxilog",
              text: this.$t("reviewJulien")
            },
            {
              author: "Lionel Godinho",
              pic: 'reviewLionPic.png',
              stars:5,
              position: this.$t('reviewLionelPosition'),
              company: null,
              text: this.$t("reviewLionel")
            },
            {
              author: "Baptiste Ravier",
              pic: 'reviewBapPic.jpeg',
              stars:5,
              position: this.$t('reviewBaptistePosition'),
              company: null,
              text: this.$t("reviewBaptiste")
            },
            {
              author: "Johan Renaudin",
              pic: 'reviewJoPic.jpeg',
              stars:5,
              position: this.$t('reviewJoPosition'),
              company: "Oncodesign",
              text: this.$t("reviewJo")
            }
          ] //un array d'objet review

        }

      },

        methods: {

            /*
            Envoi la requête pour réaliser l'inscription
            */
            sendSignupQuery(){
                this.disposableEmail = false; // reinit
                let self = this

              return self.$http
                    .post("public/signup", {
                        invitationCode: self.invitationCode,
                        email: self.email,
                        organization:{"name":self.organization},
                        name:self.name,
                        firstname:self.firstname,
                        plainPassword: self.password,
                        termsAccepted: self.termsAccepted,
                        locale: self.locale,
                        timezone: self.detectedTimezone
                    })
                    .then(function (response) {
                      self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                      // Authentification de l'user inscrit
                        self.$auth
                            .setToken(response.data.user_token)
                            .setRefreshToken(response.data.refresh_token)
                            .setOrganization(response.data.organization_slug)
                            .setRoles(response.data.user.roles)
                            .setUserSlug(response.data.user.slug)
                            .setWorkspaces(response.data.user.workspaces)
                            .setActiveWorkspace(response.data.user.workspaces[0].slug) // @todo à dynamiser lors de ticket #290 (https://gitlab.com/ousmane1/kronocloud/-/issues/290)
                            .setActiveWorkspaceCurrency(response.data.user.workspaces[0].currency) // @todo voir si à dynamiser lors de ticket #290 (https://gitlab.com/ousmane1/kronocloud/-/issues/290)

                            .saveCookie();

                        // on récup. et stocke l' user l'organization dans le store
                        self.userInitialHydration(self)

                      // déclenchement mautic
                      self.replicateSignup(self)

                      // tracking
                      self.logDataEvent(self,'LOGIN',[self.loginFrom])
                      self.$mixpanel.people.set({
                        "$distinct_id": response.data.user.slug,
                        "$email": self.email,
                        "$first_name": self.firstname,
                        "$last_name": self.name,
                        "$created": self.$moment().toISOString(),
                        "Organization": response.data.organization_slug
                      });

                      self.$mixpanel.alias(response.data.user.slug)
                      self.$mixpanel.track("signup");

                      // enregistrement de l'évenement dans analytics
                      self.ga4GlobalEventTrack('sign_up' , {method: 'email'})

                      // redirection
                      self.$router.replace({
                        name: 'signupData',
                        params: {
                          locale: self.$route.params.locale,
                          organization:response.data.organization_slug
                        }
                      })

                    })
                    .catch(function (error) {
                      //  vérification de l'erreur en cas d'email jetable
                      if(error.response.status == 400 && error.response.data.message == 'disposable email'){
                        self.disposableEmail= true;
                      }
                      else{
                        self.logToSentry(self, error, 'error')
                        let errorCode = '0013'
                        self.showGlobalErrorNotif(self,errorCode)
                        self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error in signup query"})
                        self.$gtag.exception({'description': 'error '+errorCode + ' | error in signup', 'fatal': false})
                        self.$sentry.captureMessage(`Error ${errorCode} > error in signup query : ${error}`, 'error')
                      }

                    })
                    .then(() =>{
                        // toujours exécuté
                        this.isSubmiting = false;
                    })


            },

            /*
             * Valide le formulaire avant sa soumission
             */
            validateBeforeSubmit() {
                this.$store.commit('UpdateGlobalNotificationCompVisibility', false); // on masque un éventuel message à la soumission
                this.isSubmiting = true;

                let self = this
                this.$validator.validateAll().then((result) => {
                    if (result) { // si la validation. réussie
                        this.sendSignupQuery();
                    }
                    else{ // si il y a des erreurs...
                        self.$store.commit('UpdateGlobalNotificationComp', {
                            'isVisible': true,
                            'color': 'is-danger',
                            'message': self.$t('leFormulaireContientDesErreurs')
                        });
                        this.isSubmiting = false;
                    }

                })
            },

            /*
             Retourne la validité du invitationCode
             (via une custom rule veeValidate)
             */
            validateInvitationCode() {
                let self = this
                this.$validator.extend('invitationCodeCheck', {

                    getMessage() {
                        // récupération du message d'erreur dans le dictionnaire pour i18n
                        return self.$validator.dictionary.container[self.$validator.locale].custom_validator.signup_invitation_code
                        //pas top mais je n'ai pas trouvé mieux ! (inspiré de https://github.com/baianat/vee-validate/issues/745)
                    },
                    validate() {
                        return self.$http
                            .post("public/signup/invitation-code-check", {
                                invitationCode: self.invitationCode
                            })
                            .then(function (response) {
                              self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
                              return {
                                    // la prop valid permet de valider le champs
                                    valid: response.data.valid
                                }
                            })
                            .catch(function (error) {
                                self.logToSentry(self, error, 'error')
                                let errorCode = '0014'
                                self.showGlobalErrorNotif(self,errorCode)
                                self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error checking invitation code"})
                              self.$gtag.exception({'description': 'error '+errorCode + ' | error checking invitation code', 'fatal': false})

                              self.$sentry.captureMessage(`Error ${errorCode} > error checking invitation code : ${error}`, 'error')
                            })
                    }

                });
            },

            /*
             Retourne la disponibilité de l'adresse email
             (via une custom rule veeValidate)
             */
            validateEmailAvailability() {
                let self = this
                this.$validator.extend('emailAvailabilityCheck', {

                    getMessage() {
                        // récupération du message d'erreur dans le dictionnaire pour i18n
                        return self.$validator.dictionary.container[self.$validator.locale].custom_validator.signup_email_availability //pas top mais je n'ai pas trouvé mieux ! (inspiré de https://github.com/baianat/vee-validate/issues/745)

                    },
                    validate() {
                        return self.$http
                            .post("public/signup/email-available-check", {
                                email: self.email
                            })
                            .then(function (response) {
                              self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
                              return {
                                    // la prop valid permet de valider le champs
                                    valid: response.data.valid
                                }
                            })
                            .catch(function (error) {
                                self.logToSentry(self, error, 'error')
                                let errorCode = '0015'
                                self.showGlobalErrorNotif(self,errorCode)
                                self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error checking signup email availability"})
                              self.$gtag.exception({'description': 'error '+errorCode + ' | error checking signup email availability', 'fatal': false})
                              self.$sentry.captureMessage(`Error ${errorCode} > checking signup email availability : ${error}`, 'error')
                            })
                    }

                });
            },

            /*
             Affiche la modalTerms
             */
            openModalTerms() {
                this.$store.commit('UpdateModalTermsComp', {'isVisible': true})
            },

            /**
             * Définit la valeur de this.invitationCode si un paramètre invitationCode est présent dans l'url
             */
            preFillInvitCode(){
                if(this.$route.query.invitationCode){
                    this.invitationCode = this.$route.query.invitationCode

                }
            },

          toggleRevealPwd(){
            if(this.passwordFieldType=='password'){
              this.passwordFieldType = 'text'
            }
            else if( this.passwordFieldType=='text') {
              this.passwordFieldType = 'password'
            }

          },

        },

        computed: mapState({}),

        created: function () {
            // activation des validateur custom pour invitation code et email
            this.validateInvitationCode();
            this.validateEmailAvailability();

        },
        mounted: function () {
            this.preFillInvitCode()
            this.detectedTimezone = this.detectTimezone()


          // hydratation du champ email si un paramètre d'url est présent
          if(this.$route.query.email != undefined){
            this.email = this.$route.query.email
          }

          // detection utilisation depuis pwa @todo mutualiser avec Login
          if (this.pwaIsStandalone()) {
            this.loginFrom ='standalone'
            this.$gtag.set({'pwa_mode': 'standalone'})
          }
          else{
            this.loginFrom ='browser'
            this.$gtag.set({'pwa_mode': 'browser'})
          }
        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "../assets/css/bulmaResponsiveDep.scss";

    .column {
        /*border: dashed 1px #ccc;*/
    }

    .mainContainer {
        /*border :solid 3px gold;*/
        //  box-shadow:  0 -3px 5px $brandThird;
        @include mobile {
            padding: 0 1.5rem;
            margin-top: -1.5rem;
        }
    }

    .formColumn {
        padding: 3rem 1rem;
        background: #f3f3f3;
        border-radius: 3px;

        h1 {
            margin-bottom: 2rem;
            color: $brandThird;
            /*font-size: 2rem;*/
        }

        .field {
            margin-bottom: 2rem;
        }
      .passwordReveal{
        display: block;
        margin: 0.5rem 0.2rem 0 0.5rem;
        font-size: 1rem;
        background: transparent;
        color: $brandFourth;
        border: none;
        .icon{
          display: block;
        }
      }

      .signupBtn {
            padding: 2rem 0;
            border: solid 1px transparent;
            background: $brandPrimary;
            color: white;
            &:hover {
                transition: background-color 0.3s;
                background: lighten($brandPrimary, 5%);
                color: white;
            }
            &:active {
                background: $brandThird;
                transition: background-color 0.1s;
                color: white;
            }

        }

        .columnContForm {
            @include mobile {
                padding: 0 2rem;
            }
        }
        .cgvLink {
            margin: 2rem 0;
            $color: #839ba6;
            color: $color;
            color:red;
            label{
                color:$color;
            }
            /*font-size: 0.9rem;*/
            a {
                color: $color;
                text-decoration: underline

            }
        }
        .alreadySigned {
            margin: 3rem 0 0;
            a {
                text-decoration: underline
            }

        }

    }

    .infoColumn {
        border-left: solid 1px #eee;
        padding: 3rem 1rem;
        background: #fff;
        border-top-right-radius: 25px;

        .logo {
            /*margin-bottom: 4rem;*/
          padding: 1rem 2rem 0;
          position: relative;
          display: inline-block;

          &:after{
            content: "Beta";
            font-size: .6rem;
            font-weight: bold;
            position: absolute;
            top:.2rem;
            right:0;
            color:#ccc;
            padding: .1rem .4rem;
          }


        }

        .illustration {
            /*margin-bottom: 4rem ;*/
            margin: 2rem 0;
        }
        .featList {
            margin: 3rem 0;
            text-align: left;
            color: #a0a1a1;
            h4 {
                color: $brandThird;
                font-weight: bold
            }
            li {
                list-style: inside;
            }
        }
      .reviewCont{
        //border-top: solid 1px #eee;
        padding-top: 3rem;

      }

    }


</style>
